import React, { useEffect, useState } from "react";

import { addPartner, getSettings } from "services";

import { incomplete, useCancelAsyncOnUnmount, useNavigate } from "utils";

import { AdminHead, AdminSection, Button, Col, Form, Input, InputNumber, MainPage, Row, Message as message } from "components";

export const PartnerAdd = () => {
  const [loading, setLoading] = useState(false);
  const [settings, setSettings] = useState(false);
  const signal = useCancelAsyncOnUnmount()();
  const navigate = useNavigate();

  const complete = (v) => {
    setLoading(true);

    const invoiceAddress = `${v.addressStreet}, ${v.addressNumber}`;
    const invoiceCity = `${v.zip}, ${v.addressCity}`;

    addPartner({
      ...v,
      maxHectares: settings.maxHectares,
      invoiceAddress,
      invoiceCity,
      ...{ signal },
    })
      .then(() => {
        navigate("/partners");
        message({
          content: "The gremlins accepted your sacrifice and will consume it! Nom nom nom",
          icon: "gremlin",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const loadSettings = (onComplete) => {
    setLoading(true);

    getSettings({
      signal,
    })
      .then((res) => {
        setSettings(res);

        if (onComplete) {
          onComplete();
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    loadSettings();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <MainPage loading={loading} pageName={"admin"}>
      <AdminHead
        headline="Add a partner"
        link="/partners/partners"
        tooltipText="Back to partners"
        description="Add a new partner here. The hectare limit is the maximum amount of hectares to which methods can be applied, per-farm. This will override the default hectare limit for any farm which has been attached to this partner. The point price is the amount which this partner will partner will pay per kg of carbon sequestered by any farmer attached to this partner."
      />
      <Row className="midi-form">
        <Col>
          <Form className="midi-form" name="confirm" onFinish={(v) => complete(v)} onFinishFailed={(v) => incomplete(v)}>
            <AdminSection headline="General details" />
            <Row>
              <Col>
                <Input name="name" label="Name" rules={[{ required: true }]} />
              </Col>
            </Row>

            <AdminSection headline="Point prices" />
            <Row>
              <Col md={6}>
                <InputNumber
                  initialValue={settings.pointPriceCategory1}
                  name="pointPriceCategory1"
                  label="Point price category 1"
                  rules={[{ required: true }]}
                  min={0}
                  max={1}
                  step={0.001}
                />
              </Col>
              <Col md={6}>
                <InputNumber
                  initialValue={settings.pointPriceCategory1}
                  name="pointPriceCategory2"
                  label="Point price category 2"
                  rules={[{ required: true }]}
                  min={0}
                  max={1}
                  step={0.001}
                />
              </Col>
              <Col md={6}>
                <InputNumber
                  initialValue={settings.pointPriceCategory1}
                  name="pointPriceCategory3"
                  label="Point price category 3"
                  rules={[{ required: true }]}
                  min={0}
                  max={1}
                  step={0.001}
                />
              </Col>
              <Col md={6}>
                <InputNumber
                  initialValue={settings.pointPriceCategory4}
                  name="pointPriceCategory4"
                  label="Point price category 4"
                  rules={[{ required: true }]}
                  min={0}
                  max={1}
                  step={0.001}
                />
              </Col>
            </Row>

            <AdminSection headline="Contact info" />
            <Row>
              <Col>
                <Input name="contactName" label="Contact person" rules={[{ required: false }]} />
              </Col>
            </Row>
            <Row>
              <Col sm={24} md={12}>
                <Input name="contactEmail" label="Contact email" rules={[{ required: false }]} />
              </Col>
              <Col sm={24} md={12}>
                <Input name="contactPhone" label="Contact phone" rules={[{ required: false }]} />
              </Col>
            </Row>

            <AdminSection headline="Invoicing info" />
            <Row>
              <Col sm={24} md={18}>
                <Input name="addressStreet" label="Street" rules={[{ required: true }]} />
              </Col>
              <Col sm={24} md={6}>
                <Input name="addressNumber" label="Street Number" rules={[{ required: true }]} />
              </Col>
            </Row>

            <Row>
              <Col sm={24} md={18}>
                <Input name="addressCity" label="City" rules={[{ required: true }]} />
              </Col>
              <Col sm={24} md={6}>
                <InputNumber name="zip" label="ZIP" rules={[{ required: true }]} />
              </Col>
            </Row>

            <Row>
              <Col sm={24} md={24}>
                <Input name="invoiceCountry" label="Country" rules={[{ required: true }]} />
              </Col>
            </Row>

            <Row>
              <Col>
                <Form.Item>
                  <Button type="primary" htmlType="submit" disabled={loading} loading={loading}>
                    Save
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>
    </MainPage>
  );
};
